/**
 * The authoring dialog's frame, the way RoutesDialog frames the route
 * explorer: a bare antd Modal, conditional-mounted, so the floor being
 * designed is built fresh on every open and nothing half-edited survives a
 * close. What was saved is saved (fab/floorPlan.ts); what was not is gone,
 * which is the right default for a surface that can throw a whole fab away
 * in one sentence.
 */

import { Modal } from 'antd'
import { tOr } from '../../i18n/i18n'
import { useLang } from '../i18n/LanguageProvider'
import { FabAuthorView } from './FabAuthorView'

export function FabAuthorDialog({ onClose }: { onClose: () => void }) {
  useLang()
  return (
    <Modal
      open
      onCancel={onClose}
      footer={null}
      title={tOr('author.Title', 'Design a fab')}
      width="min(1320px, 97vw)"
      styles={{ body: { maxHeight: '82vh', overflowY: 'auto' } }}
      centered
    >
      <FabAuthorView onClose={onClose} />
    </Modal>
  )
}
